export default "__VITE_ASSET__2bc88d65__"